import './home.css'
import './privacyhushold.css'
import wwwwoohooo from './assets/home/wwwwoohooo.png'

import rankytanktitle from './assets/home/husholdtitle.png'
import husholdremovealldata from './assets/home/husholdremovealldata.png'
import husholdremovealldataconfirm from './assets/home/husholdremovealldataconfirm.png'


import Footer from './footer'

function HusholdPrivacy() {
  return (
    <div className="page">
      <div className="main_page">
        <a href="/">
          <img className="woohooologo" src={wwwwoohooo} />
        </a>
      </div>

      <div className="main_page" style={{ paddingBottom: 10, display: 'flex' }}>
        <div className="rankytank" style={{ flex: 1, marginTop: '1vw' }}>
          <div>
            <a href="/hushold" className="woohooologo">
              <img className="husholdtitle2" src={rankytanktitle} />
            </a>
          </div>
          <div className="rankytanksubtitleprivacy" style={{ marginTop: '1vw', marginBottom: '1vw' }}>
            Privacy
          </div>
          {/* <img className="rankytanklogo" src={rankytanklogo} /> */}

          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div className='privacy_description' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <p className="pheader">Hvad vi indsamler</p>
              <p className="ptext">Vi gemmer kun de oplysninger, du selv giver os, f.eks. navn, e-mail og dine varer i Hushold-appen.</p>

              <p className="pheader">Hvordan vi bruger det</p>
              <p className="ptext">
                Dine oplysninger bruges udelukkende til at levere og forbedre Hushold. Vi hverken sælger eller deler dine data med tredjeparter uden dit
                samtykke.
              </p>

              <p className="pheader">Hvordan vi beskytter det</p>
              <p className="ptext">
                Vi tager sikkerhed alvorligt og bruger standardteknologier til at beskytte dine data. Du kan til enhver tid slette din konto og dine
                oplysninger.
              </p>

              <p className="pheader">Hvordan du sletter det</p>
              <p className="ptext">
                Hvis du ikke længere ønsker at bruge Hushold, kan du til enhver tid slette alle dine data via appens indstillinger, som vist i illustrationerne nedenfor.
              </p>
              <p>
                <img className="husholdremovealldata" src={husholdremovealldata} />
                <img className="husholdremovealldataconfirm" src={husholdremovealldataconfirm} />
              </p>
            </div>
          </div>
          {/* <div>
            <div>
              <div className="rankytankapplestore">
                <a href="https://apps.apple.com/us/app/rankytank/id1642592019">
                  <img src={wwwappstore15pct} />
                </a>
              </div>
              <div className="rankytankgoogleplay">
                <a href="https://play.google.com/store/apps/details?id=com.rankytank2">
                  <img src={wwwgoogleplay15pct} />
                </a>
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <div style={{ display: 'flex', gap: 5, flexDirection: 'column' }}>
                <div style={{ display: 'flex', gap: 5 }}>
                  <div style={{}}>
                    <a href="/privacyhushold">
                      <img src={privacybutton} />
                    </a>
                  </div>
                  <div style={{}}>
                    <a href="/supporthushold">
                      <img src={supportbutton} />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default HusholdPrivacy
